import { render } from "./MypageHome.vue?vue&type=template&id=722b51b9&scoped=true"
import script from "./MypageHome.vue?vue&type=script&lang=js"
export * from "./MypageHome.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_home.css?vue&type=style&index=0&id=722b51b9&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722b51b9"]])

export default __exports__